module.exports = __webpack_public_path__ + "static/media/filters-white.77976038.svg";